<template>
    <div>
        <div class="form-group">
            <label class="col-md-2 control-label">GENERAL TOPOGRAPHIC SETTING</label>
            <div class="col-md-10">
                <label v-if="!qaqcEnabled"><span>&nbsp;</span></label>
                <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'siteSettingTopographyList'" :hasAppend="true"></qaqcFormFieldSelect>
                <checkBoxPanel :numColumns="4" :lookupList="topographicSettingList" ref="topoSettingCheckboxPanel" :fieldName="'topographicSettingId'" :name="qaqcFieldId + 'siteSettingTopoCB'" />
            </div>
        </div>
        <div class="form-group">
            <label class="col-md-2 control-label">Geographic Division</label>
            <div class="col-md-10">
                <label v-if="!qaqcEnabled"><span>&nbsp;</span></label>
                <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'siteSettingDivisionList'" :hasAppend="true"></qaqcFormFieldSelect>
                <checkBoxPanel :numColumns="4" :lookupList="geographicDivisionList" ref="divisionCheckboxPanel" :fieldName="'geographicDivisionId'" :name="qaqcFieldId + 'siteSettingDivisionCB'"/>
            </div>
        </div>
        <div class="form-group">
            <label class="col-md-2 control-label">UNIQUE SITE SETTING</label>
            <div class="col-md-10">
                <div class="form-inline">
                    <label><span>Check as appropriate, describe site setting in general narrative</span></label>
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'siteSettingUniqueSettingList'" :hasAppend="true"></qaqcFormFieldSelect>
                </div>
                <checkBoxPanel :numColumns="4" :lookupList="uniqueSettingList" ref="uniqueSettingCheckboxPanel" :fieldName="'uniqueSettingId'" :name="qaqcFieldId + 'siteSettingUniqueCB'" />
            </div>
        </div>
        <div class="form-group">
            <label class="col-md-2 control-label">BARE GROUND PERCENTAGE</label>
            <div class="col-md-5" :class="{'form-inline': qaqcEnabled}">
                <input type="number" class="form-control"  v-model="siteSetting.percentBareGround" />
                <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'percentBareGround'" :hasAppend="false"></qaqcFormFieldSelect>
            </div>
        </div>
        <div class="form-group">
            <label class="col-md-2 control-label">GENERAL TOPOGRAPHIC SETTING</label>
            <div class="col-md-4">
                <div class="form-inline">
                    <label><span>Few words</span></label>
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'generalTopographicSetting'" :hasAppend="true"></qaqcFormFieldSelect>
                </div>
                <input type="text" class="form-control" v-model="siteSetting.generalTopographicSetting">
            </div>
        </div>
        <div class="form-group">
            <label class="col-md-2 control-label">VEGETATION ASSOCIATION</label>
            <div class="col-md-10">
                <label v-if="!qaqcEnabled"><span>&nbsp;</span></label>
                <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'siteSettingVegetationList'" :hasAppend="true"></qaqcFormFieldSelect>
                <checkBoxPanel :numColumns="4" :lookupList="vegetationTypeList" ref="vegetationCheckboxPanel" :fieldName="'vegetationTypeId'" :name="qaqcFieldId + 'siteSettingVegetationCB'" />
            </div>
        </div>
        <div class="form-group">
            <label class="col-md-2 control-label">GENERAL DEPOSITIONAL ENVIRONMENT</label>
            <div class="col-md-10">
                <div class="form-inline">
                    <label><span>Check as appropriate, describe site setting in general narrative</span></label>
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'siteSettingDepositionalTypeList'" :hasAppend="true"></qaqcFormFieldSelect>
                </div>
                <checkBoxPanel :numColumns="4" :lookupList="depositionalTypeList" ref="depositionalCheckboxPanel" :fieldName="'depositionalTypeId'" :name="qaqcFieldId + 'siteSettingGeneralDepositionCB'"/>
            </div>
        </div>
        <div class="form-group">
            <label class="col-md-2 control-label">AEOLIAN SETTINGS</label>
            <div class="col-md-3">
                <label><span>Late Pleistocene and Holocene aeolian deposits</span></label>
                <div class="form-inline">
                    <select class="form-control" v-model="siteSetting.aeolianSettingsId">
                        <option :value="1">Yes</option>
                        <option :value="2">No</option>
                        <option :value="3">Unknown</option>
                        <option :value="4">Not Applicable</option>
                    </select>
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'aeolianSettingsId'" :hasAppend="false"></qaqcFormFieldSelect>
                </div>
            </div>
            <div class="col-md-7" v-show="siteSetting.aeolianSettingsId == 1">
                <div class="form-inline">
                    <label><span>Type(s) of aeolian setting(s)</span></label>
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'siteSettingAeolianTypeList'" :hasAppend="true"></qaqcFormFieldSelect>
                </div>
                <checkBoxPanel :numColumns="4" :lookupList="aeolianTypeList" ref="aeolianCheckboxPanel" :fieldName="'aeolianTypeId'" :name="qaqcFieldId + 'siteSettingAeolianCB'"/>
            </div>
        </div>
        <div class="form-group">
            <label class="col-md-2 control-label">SUBSURFACE POTENTIAL</label>
            <div class="col-md-3">
                <label><span>Archaeological subsurface deposits</span></label>
                <div class="form-inline">
                    <select class="form-control" v-model="siteSetting.subsurfacePotentialId">
                        <option :value="1">Yes</option>
                        <option :value="2">No</option>
                        <option :value="3">Unknown</option>
                        <option :value="4">Not Applicable</option>
                    </select>
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'subsurfacePotentialId'" :hasAppend="false"></qaqcFormFieldSelect>
                </div>
            </div>
            <div class="col-md-7"  v-show="siteSetting.subsurfacePotentialId == 1">
                <div class="form-inline">
                    <label><span>Estimate based on</span></label>
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'siteSettingDepositEstimateBasisList'" :hasAppend="true"></qaqcFormFieldSelect>
                </div>
                <checkBoxPanel :numColumns="4" :lookupList="depositEstimateBasisList" ref="estimateCheckboxPanel" :fieldName="'depositEstimateBasisId'" :name="qaqcFieldId + 'siteSettingDepoEstimateCB'" />
            </div>
        </div>
        <div v-if="!(qaqcEnabled || formDisabled)" class="form-group">
            <div class="col-md-2">
                <button class="btn btn-primary pull-right" v-on:click="saveSiteSetting">Save</button>
            </div>
        </div>
        <qaqcFormFieldFooter v-if="qaqcEnabled" :qaqcProgressDto="qaqcProgressDto" :qaqcSelection="qaqcSelection" :sectionName="'siteSetting'" :completeSection="completeSection"></qaqcFormFieldFooter>
    </div>
</template>

<script>
import loggingService from '../../services/util/loggingService'
import siteSettingService from '../../services/siteForm/siteSettingService'
// import qaqcService from '@/services/qaqcService'

import loader from '../Loader.vue'
import checkBoxPanel from '../CheckBoxPanel.vue'
import qaqcFormFieldSelect from '@/components/SiteForm/QaqcFormFieldSelect.vue'
import qaqcFormFieldFooter from '@/components/SiteForm/QaqcFormFieldFooter.vue'

export default {
    name: 'siteSettingForm',
    components: {
        loader,
        checkBoxPanel,
        qaqcFormFieldSelect,
        qaqcFormFieldFooter
    },
    props: {
        formDisabled: { default: false },
        qaqcEnabled: { default: false },
        qaqcProgressDto: { default: () => {} },
        saveQaqcProgress: { default: null },
        crrId: { default: null }
    },
    data: function () {
        return {
            isDebug: false,
            isLoading: false,
            aeolianTypeList: [],
            depositEstimateBasisList: [],
            depositionalTypeList: [],
            topographicSettingList: [],
            uniqueSettingList: [],
            vegetationTypeList: [],
            geographicDivisionList: [],
            siteSetting: {}
        }
    },
    computed: {
        qaqcSelection: function () {
            if (this.qaqcProgressDto && this.qaqcProgressDto.qaqcSelections) {
                // // if there's no propertyDescription qa/qc object, create new instance
                // if (!this.qaqcProgressDto.qaqcSelections.siteSetting) {
                //     this.qaqcProgressDto.qaqcSelections.siteSetting = qaqcService.qaqcSelections().siteSetting
                // }
                return this.qaqcProgressDto.qaqcSelections.siteSetting
            } else {
                return {}
            }
        },
        qaqcFieldId: function () {
            return this.qaqcEnabled ? 'qaqc' : ''
        }
    },
    watch: {
        crrId: function (val) {
            this.log('crrId is changed: ' + val)
            this.loadData().then(result => {
                this.loadLookups()
                this.isLoading = false
            })
        }
    },
    mounted () {
        this.isLoading = true
        if (this.crrId) {
            this.loadData().then(result => {
                this.loadLookups()
                this.isLoading = false
            })
        }
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'Site Setting Form', message)
        },
        loadAeolianTypes () {
            var searchDto = {siteSettingId: this.siteSetting.siteSettingId}
            return siteSettingService.searchAeolianType(this.$http, searchDto).then(result => {
                this.$refs.aeolianCheckboxPanel.selectedList = result.data.map(x => {
                    return x.aeolianTypeId
                })
                return result
            })
        },
        loadDepositEstimateBasis () {
            var searchDto = {siteSettingId: this.siteSetting.siteSettingId}
            return siteSettingService.searchSiteSettingDepositEstimateBasis(this.$http, searchDto).then(result => {
                this.$refs.estimateCheckboxPanel.selectedList = result.data.map(x => {
                    return x.depositEstimateBasisId
                })
                return result
            })
        },
        loadDepositionalType () {
            var searchDto = {siteSettingId: this.siteSetting.siteSettingId}
            return siteSettingService.searchSiteSettingDepositionalType(this.$http, searchDto).then(result => {
                this.$refs.depositionalCheckboxPanel.selectedList = result.data.map(x => {
                    return x.depositionalTypeId
                })
                return result
            })
        },
        loadTopographySetting () {
            var searchDto = {siteSettingId: this.siteSetting.siteSettingId}
            return siteSettingService.searchSiteSettingTopography(this.$http, searchDto).then(result => {
                this.$refs.topoSettingCheckboxPanel.selectedList = result.data.map(x => {
                    return x.topographicSettingId
                })
                return result
            })
        },
        loadUniqueSetting () {
            var searchDto = {siteSettingId: this.siteSetting.siteSettingId}
            return siteSettingService.searchSiteSettingUniqueSetting(this.$http, searchDto).then(result => {
                this.$refs.uniqueSettingCheckboxPanel.selectedList = result.data.map(x => {
                    return x.uniqueSettingId
                })
                return result
            })
        },
        loadVegetationTypes () {
            var searchDto = {siteSettingId: this.siteSetting.siteSettingId}
            return siteSettingService.searchSiteSettingVegetation(this.$http, searchDto).then(result => {
                this.$refs.vegetationCheckboxPanel.selectedList = result.data.map(x => {
                    return x.vegetationTypeId
                })
                return result
            })
        },
        loadDivisions () {
            var searchDto = {siteSettingId: this.siteSetting.siteSettingId}
            return siteSettingService.searchSiteSettingDivision(this.$http, searchDto).then(result => {
                this.$refs.divisionCheckboxPanel.selectedList = result.data.map(x => {
                    return x.geographicDivisionId
                })
                return result
            })
        },
        loadLookups () {
            this.aeolianTypeList = siteSettingService.getAeolianTypeList()
            this.depositEstimateBasisList = siteSettingService.getDepositEstimateBasisList()
            this.depositionalTypeList = siteSettingService.getDepositionalTypeList()
            this.topographicSettingList = siteSettingService.getTopographicSettingList()
            this.uniqueSettingList = siteSettingService.getUniqueSettingList()
            this.vegetationTypeList = siteSettingService.getVegetationTypeList()
            this.geographicDivisionList = siteSettingService.getGeographicDivisionList()
        },
        createNewInstance () {
            this.siteSetting = {
                culturalResourceRecordingId: this.crrId,
                aeolianSettingsId: '',
                subsurfacePotentialId: ''
            }
        },
        loadData () {
            var crrId = this.crrId
            this.log('Searching site settings for ' + crrId)
            return siteSettingService.searchSiteSetting(this.$http, {culturalResourceRecordingId: crrId}).then(response => {
                if (response.data.length > 0) {
                    this.log('found one response')
                    this.siteSetting = response.data[0]
                    Promise.all([
                        this.loadAeolianTypes(),
                        this.loadDepositEstimateBasis(),
                        this.loadDepositionalType(),
                        this.loadTopographySetting(),
                        this.loadUniqueSetting(),
                        this.loadVegetationTypes(),
                        this.loadDivisions()
                    ]).then(response2 => {
                        this.log('done loading others')
                        return response2
                    })
                } else {
                    this.log('creating new instance')
                    return this.createNewInstance()
                }
            })
        },
        saveSiteSetting () {
            var siteSettingId = this.siteSetting.siteSettingId
            //set each component in siteSetting
            this.siteSetting.siteSettingAeolianTypeList = this.$refs.aeolianCheckboxPanel.selectedList.map(x => {
                return {
                    siteSettingId: siteSettingId,
                    aeolianTypeId: x
                }
            })
            this.siteSetting.siteSettingDepositEstimateBasisList = this.$refs.estimateCheckboxPanel.selectedList.map(x => {
                return {
                    siteSettingId: siteSettingId,
                    depositEstimateBasisId: x
                }
            })
            this.siteSetting.siteSettingDepositionalTypeList = this.$refs.depositionalCheckboxPanel.selectedList.map(x => {
                return {
                    siteSettingId: siteSettingId,
                    depositionalTypeId: x
                }
            })
            this.siteSetting.siteSettingTopographyList = this.$refs.topoSettingCheckboxPanel.selectedList.map(x => {
                return {
                    siteSettingId: siteSettingId,
                    topographicSettingId: x
                }
            })
            this.siteSetting.siteSettingUniqueSettingList = this.$refs.uniqueSettingCheckboxPanel.selectedList.map(x => {
                return {
                    siteSettingId: siteSettingId,
                    uniqueSettingId: x
                }
            })
            this.siteSetting.siteSettingVegetationList = this.$refs.vegetationCheckboxPanel.selectedList.map(x => {
                return {
                    siteSettingId: siteSettingId,
                    vegetationTypeId: x
                }
            })
            this.siteSetting.siteSettingDivisionList = this.$refs.divisionCheckboxPanel.selectedList.map(x => {
                return {
                    siteSettingId: siteSettingId,
                    geographicDivisionId: x
                }
            })
            siteSettingService.putSiteSetting(this.$http, this.siteSetting).then(result => {
                this.loadData().then(result2 => {
                    this.log('save complete')
                })
            })
        },
        completeSection (sectionName) {
            //conditional selects.  If aoelianSettingId or subsurfacePotentialId aren't 1 (yes), default the dependency selections to 2 (ignore)
            if (Number(this.siteSetting.aeolianSettingsId) !== 1) { this.qaqcSelection.siteSettingAeolianTypeList = 2 }
            if (Number(this.siteSetting.subsurfacePotentialId) !== 1) { this.qaqcSelection.siteSettingDepositEstimateBasisList = 2 }

            // check if all selections have been made
            if (Object.values(this.qaqcSelection).includes(0)) {
                alert('Please complete all QA/QC selections in this section.')
                return
            }
            this.saveSiteSetting()
            this.saveQaqcProgress(sectionName, true)
        }
    }
}
</script>



// WEBPACK FOOTER //
// SiteSettingForm.vue?73df21b2